import styles from './section.module.scss';
import { Typography, Stack } from '@mui/material';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Flex } from 'ui';

export const Section = ({ children, className, ...props }) => {
  const { align, link, title, subtitle, withoutEmptyContent, ...rest } = props;

  return (
    <Stack
      className={classnames(styles.root, className, {
        [styles.withoutEmptyContent]: withoutEmptyContent,
        [styles.alignCenter]: props.align === 'center',
      })}
      component="section"
      spacing={2.5}
      align={align}
      {...rest}
    >
      {title && (
        <Flex align="flex-end" justify={align || 'space-between'}>
          <Stack spacing={0.5}>
            {title && <Typography variant="h2">{title}</Typography>}
            {subtitle && <Typography variant="body2">{subtitle}</Typography>}
          </Stack>
          {link && (
            <Typography variant="body2" component="a" href={link}>
              Ver más
            </Typography>
          )}
        </Flex>
      )}
      <Stack
        component="article"
        alignItems={props.align}
        spacing={props.spacing}
      >
        {children}
      </Stack>
    </Stack>
  );
};

Section.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  sx: PropTypes.object,
  id: PropTypes.string,
};
